import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import "./SendCampaign.css";

const SendWhatsAppCampaign = () => {
  // Common state
  const [numbercounter, setNumberCounter] = useState("");
  const [mobile_no, setMobile_No] = useState("");
  const [count, setCount] = useState(0);
  const [contactGroupData, setContactGroupData] = useState([]);
  const [isloading, setLoading] = useState(false);
  const [responseNumber, setResponseNumber] = useState("");

  // WhatsApp state
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [selectedTemplateType, setSelectedTemplateType] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const token = localStorage.getItem("token"); // Retrieve token from local storage

  const BASE_URL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const theme = localStorage.getItem("theme");
    document.body.className = theme;
    if (numbercounter.length == 0) {
      setNumberCounter(0);
    }
  }, [count]);

  const getWhatsAppTemplates = () => {
    const token = localStorage.getItem("token"); // Retrieve token from local storage
    axios
      .post(
        `${BASE_URL}admin/getAllTemplates`,
        { statusFilter: "approved" },
        {
          headers: {
            "x-access-token": `${token}`,
            version: "1.0.0",
            "Content-Type": "Application/json",
          },
        }
      )
      .then((response) => {
        setTemplates(response.data.data.data || []);
      })
      .catch((error) => {
        console.log("Error fetching templates:", error);
      });
  };

  const GetAllContactGroup = () => {
    const token = localStorage.getItem("token"); // Retrieve token from local storage
    axios
      .post(
        `${BASE_URL}admin/getAllContactGroup`,
        { page: 1 },
        {
          headers: {
            "x-access-token": `${token}`,
            version: "1.0.0",
            "Content-Type": "Application/json",
          },
        }
      )
      .then((response) => {
        if (response.data.success !== false) {
          setContactGroupData(response.data.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getWhatsAppTemplates();
    GetAllContactGroup();
    const theme = localStorage.getItem("theme");
    document.body.className = theme;
  }, []);

  const handleImageUpload = (e) => {
    setImageFile(e.target.files[0]);
  };
  const RowCount = (text) => {
    // Filter to allow only digits and newlines (remove all letters and special chars except newlines)
    const filteredText = text.replace(/[^0-9\n\r]/g, '');
    var lines = filteredText.split(/\r|\r\n|\n/);
    setCount(lines.length);
    setNumberCounter(count);
    setMobile_No(filteredText);
  };

  const submitWhatsAppTemplate = () => {
    setLoading(true);
    if (!selectedTemplate) {
      toast.error("Template is mandatory");
      setLoading(false);
      return;
    }

    // if (selectedTemplateType === "image" && !imageFile) {
    //   toast.error("Image is required for image templates");
    //   setLoading(false);
    //   return;
    // }

    // Create FormData only if we have an image file
    if (selectedTemplateType === "image" && imageFile) {
      const formData = new FormData();
      formData.append("contact_no", mobile_no);
      formData.append("msg_count", count);
      formData.append("template_id", selectedTemplate);
      formData.append("media_type", "WHATSAPP");
      // formData.append("image", imageFile);

      axios
        .post(`${BASE_URL}admin/addSendMessage`, formData, {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "multipart/form-data",
            version: "1.0.0",
          },
        })
        .then((response) => {
          if (response.data.success == false) {
            toast.error(response.data.message);
          } else {
            toast.success(response.data.message);
            setNumberCounter("");
            setMobile_No("");
            setImageFile(null);
          }
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    } else {
      // Regular JSON request for non-image templates
      axios
        .post(
          `${BASE_URL}admin/addSendMessage`,
          {
            contact_no: mobile_no,
            msg_count: count,
            template_id: selectedTemplate,
            media_type: "WHATSAPP",
          },
          {
            headers: {
              "x-access-token": `${token}`,
              "Content-Type": "Application/json",
              version: "1.0.0",
            },
          }
        )
        .then((response) => {
          if (response.data.success == false) {
            toast.error(response.data.message);
          } else {
            toast.success(response.data.message);
            setNumberCounter("");
            setMobile_No("");
          }
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    }
  };

  // Group selection handler
  const GroupRowCount = (text) => {
    var lines = text.split(/\r|\r\n|\n/);

    setCount(lines.length);

    setNumberCounter(count);
    setMobile_No(text);
  };

  const sanitizeNumbers = (rawValues) => {
    const seen = new Set();
    const result = [];
    for (const val of rawValues) {
      const num = String(val).trim().replace(/[^0-9]/g, "");
      if (num && !seen.has(num)) {
        seen.add(num);
        result.push(num);
      }
    }
    return result;
  };

  const handleFileImport = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const fileName = file.name.toLowerCase();

    if (fileName.endsWith(".csv")) {
      Papa.parse(file, {
        skipEmptyLines: true,
        complete: (results) => {
          const rawValues = results.data.map((row) => row[0]).filter((v) => v !== undefined && v !== null);
          const numbers = sanitizeNumbers(rawValues);
          const text = numbers.join("\n");
          setMobile_No(text);
          setCount(numbers.length);
        },
      });
    } else if (fileName.endsWith(".xlsx") || fileName.endsWith(".xls")) {
      const reader = new FileReader();
      reader.onload = (ev) => {
        const data = new Uint8Array(ev.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const rows = XLSX.utils.sheet_to_json(sheet, { header: 1 });
        const rawValues = rows.map((row) => row[0]).filter((v) => v !== undefined && v !== null);
        const numbers = sanitizeNumbers(rawValues);
        const text = numbers.join("\n");
        setMobile_No(text);
        setCount(numbers.length);
      };
      reader.readAsArrayBuffer(file);
    } else {
      toast.error("Please upload a .csv, .xlsx, or .xls file");
    }
    e.target.value = "";
  };
  return (
    <div className="send-campaign-container">
      <div className="send-campaign-card card">
        <div className="send-campaign-header card-header">
          <h6>Send Whatsapp message</h6>
        </div>
        <div className="send-campaign-body card-body">
          {/* Mobile Number Input */}
          <div className="form-group-responsive">
            <label className="form-label-responsive">Enter Mobile Number:-</label>
            <textarea
              rows={4}
              className="form-control-responsive"
              placeholder="Enter 10 digits mobile number here)"
              onChange={(e) => RowCount(e.target.value)}
              name="mobile_no"
              value={mobile_no}
            ></textarea>
          </div>

          {/* Select Template */}
          <div className="form-group-responsive">
            <label className="form-label-responsive">Select Template:-</label>
            <select
              className="form-control-responsive"
              onChange={(e) => {
                const selectedId = e.target.value;
                setSelectedTemplate(selectedId);

                // Find the template and update the template type
                const template = templates.find(
                  (t) => t._id === selectedId
                );
                if (template) {
                  setSelectedTemplateType(template.templateType);
                }
              }}
              defaultValue=""
            >
              <option value="" disabled>
                Select WhatsApp template
              </option>
              {templates.map((template) => (
                <option key={template._id} value={template._id}>
                  {template.templateName}
                </option>
              ))}
            </select>
          </div>

          {/* Counter display */}
          <div className="form-group-responsive">
            <label className="form-label-responsive">Count:-</label>
            <input
              type="text"
              className="form-control-responsive"
              name="numbercounter"
              value={count}
              disabled
            />
          </div>

          {/* Group import */}
          <div className="form-group-responsive">
            <label className="form-label-responsive">Group Import</label>
            <select
              className="form-control-responsive"
              onChange={(e) => GroupRowCount(e.target.value)}
              defaultValue=""
            >
              <option value="" disabled>--select--</option>
              {contactGroupData &&
                contactGroupData.map((item, index) => (
                  <option key={index} value={item.contact_no}>
                    {item.group_name}
                  </option>
                ))}
            </select>
          </div>

          {/* CSV / Excel Import */}
          <div className="form-group-responsive">
            <label className="form-label-responsive">CSV / Excel Import</label>
            <input
              type="file"
              className="form-control-responsive"
              accept=".csv,.xlsx,.xls"
              onChange={handleFileImport}
            />
          </div>

          {/* Submit button */}
          <div className="submit-btn-container">
            {isloading ? (
              <button
                type="button"
                className="btn btn-primary "
                disabled
              >
                <i className="fa fa-spinner fa-spin  "></i>
              </button>
            ) : (
              <button
                type="button"
                className="btn btn-primary "
                onClick={submitWhatsAppTemplate}
              >
                Submit
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SendWhatsAppCampaign;
